'use client';

import { GseMockExportCard } from '@slims/ui/molecules';
import { useState } from 'react';
import { toast } from 'sonner';
import { apiFetch } from '@/lib/utils/api';
import { useContextOrg } from '@/hooks/use-context-org';

/** Wiring for GseMockExportCard: fetches the mock GSE CSV from the Worker and downloads it. */
export function GseMockExport() {
	const [busy, setBusy] = useState(false);
	const contextOrg = useContextOrg();

	async function handleExport(from: string, to: string) {
		if (!/^\d{4}-\d{2}$/.test(to)) {
			toast.error('Seleziona un mese valido');
			return;
		}
		if (!contextOrg) {
			toast.error('Nessuna configurazione selezionata');
			return;
		}
		setBusy(true);
		try {
			const res = await apiFetch(
				`/api/reports/gse-mock?from=${from}&to=${to}&orgId=${contextOrg.orgId}`,
			);
			if (!res.ok) {
				const body = (await res.json().catch(() => null)) as { error?: string } | null;
				throw new Error(body?.error ?? `Errore ${res.status}`);
			}
			const blob = await res.blob();
			const cd = res.headers.get('Content-Disposition') ?? '';
			const filename = /filename="([^"]+)"/.exec(cd)?.[1] ?? `GSE_Misure15min_${from}_${to}.csv`;
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = filename;
			a.click();
			URL.revokeObjectURL(url);
			toast.success(`CSV generato: ${filename}`);
		} catch (err) {
			toast.error(err instanceof Error ? err.message : 'Errore nella generazione del CSV');
		} finally {
			setBusy(false);
		}
	}

	return <GseMockExportCard busy={busy} onExport={handleExport} />;
}
